import {Component, contentChild, input, output, TemplateRef} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {Select} from 'primeng/select';
import {FloatLabel} from 'primeng/floatlabel';
import {FormControl, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Message} from 'primeng/message';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'elcia-dropdown',
  imports: [
    Select,
    FloatLabel,
    NgTemplateOutlet,
    FormsModule,
    ReactiveFormsModule,
    Message,
    TranslatePipe
  ],
  templateUrl: './dropdown.html',
  styleUrl: './dropdown.scss',
})
export class Dropdown<T> {
  items = input.required<T[]>();
  textField = input<string>('name');
  valueField = input<string>('id');
  scrollHeight = input<string>('300px');
  label = input.required<string>();
  // Name of the item's boolean field that, when true, disables the option (e.g. 'disabled'). Unset = no option disabled.
  optionDisabled = input<string>();
  itemTemplate = contentChild<TemplateRef<any>>('item');
  control = input.required<FormControl<unknown>>();
  selectionChange = output<unknown>();

  // Method (not a computed): the required validator can be toggled at runtime on the same control
  // instance, so it must be re-evaluated on each change detection, not memoized on the control ref.
  isRequired(): boolean {
    return this.control().hasValidator(Validators.required);
  }
}

export interface DropdownItem {
  name: string;
  id: string;
  imageUrl?: string;
}
